import * as Tabs from '@radix-ui/react-tabs';
import { motion, AnimatePresence } from 'framer-motion';
import SearchBar from 'components/shared/SearchBar';
import { FiPlus } from 'react-icons/fi';

interface GuidesTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  children: React.ReactNode;
  onAddNew: () => void;
  searchTerm: string;
  onSearch: (value: string) => void;
}

export default function GuidesTabs({ 
  activeTab, 
  onTabChange, 
  children, 
  onAddNew,
  searchTerm,
  onSearch
}: GuidesTabsProps) {
  return (
    <div>
      <Tabs.Root value={activeTab} onValueChange={onTabChange}>
        <div className="sticky top-0 pt-4 bg-black z-20">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-xl font-semibold text-white">Guides Management</h1>
          </div>
          <Tabs.List className="flex w-full">
            <Tabs.Trigger
              value="guides"
              className={`px-6 py-2.5 text-sm transition-colors relative flex-1 max-w-[200px] ${
                activeTab === 'guides'
                  ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white rounded-lg'
                  : 'bg-[#2A2A2A] text-gray-400 rounded-l-lg'
              }`}
            >
              Guides
            </Tabs.Trigger>
            <Tabs.Trigger
              value="categories"
              className={`px-6 py-2.5 text-sm transition-colors relative flex-1 max-w-[200px] ${
                activeTab === 'categories'
                  ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white rounded-lg'
                  : 'bg-[#2A2A2A] text-gray-400 rounded-r-lg'
              }`}
            >
              Categories
            </Tabs.Trigger>
            <div className="flex-1 bg-[#2A2A2A] h-full" />
          </Tabs.List>
          <div className="sticky top-[100px] pt-4 bg-black z-10">
          <div className='flex justify-between items-center bg-black pb-4'>
            <SearchBar
              value={searchTerm}
              onChange={onSearch}
              placeholder={`Search ${activeTab}...`}
            />
            <button
              onClick={onAddNew}
              className="flex items-center gap-2 bg-[#2A2A2A] rounded-md px-4 py-2 text-white"
            >
              <FiPlus /> Add {activeTab === 'guides' ? 'Guide' : 'Category'}
            </button>
          </div>
        </div>
        </div>

      

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.15 }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </Tabs.Root>
    </div>
  );
} 